import { useHaicPageTitle } from '@shared-legacy/ui-kit';

/**
 * Sets the browser tab/page title.
 * Re-exports useHaicPageTitle with a cleaner name.
 */
export const usePageTitle = useHaicPageTitle;
